import { useState } from "react";
import { Instagram, LoaderCircle, Plus, Trash2 } from "lucide-react";
import { eventsApi } from "@/services/eventsApi";

const formatDate = (value) => new Intl.DateTimeFormat("en-IN", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(value));

export const InstagramPanel = ({ posts, csrfToken, onChanged }) => {
  const [url, setUrl] = useState("");
  const [caption, setCaption] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const add = async (e) => {
    e.preventDefault(); setState("saving"); setError("");
    try {
      await eventsApi.post("/admin/instagram", { url, caption }, { headers: { "X-CSRF-Token": csrfToken } });
      setUrl(""); setCaption(""); setState("idle"); onChanged();
    } catch (err) {
      setState("idle");
      setError(err.response?.data?.detail || "The post could not be added. Check the URL and try again.");
    }
  };
  const remove = async (post) => {
    if (!window.confirm("Remove this Instagram post from the site feed?")) return;
    try { await eventsApi.delete(`/admin/instagram/${post.post_id}`, { headers: { "X-CSRF-Token": csrfToken } }); onChanged(); } catch { setError("The post could not be removed."); }
  };

  return (
    <section className="admin-panel" data-testid="admin-instagram-panel">
      <div className="admin-panel-heading"><div><p className="eyebrow">Curated social feed</p><h2>INSTAGRAM POSTS</h2></div><p>Shown on Home and Events · newest first</p></div>
      <form className="instagram-add-form" onSubmit={add} data-testid="instagram-add-form">
        <label>Instagram post URL<input required type="url" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://www.instagram.com/p/..." maxLength="500" data-testid="instagram-url-input" /></label>
        <label>Caption for SEO & accessibility <small>optional, recommended</small><input value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Short description of the post" maxLength="360" data-testid="instagram-caption-input" /></label>
        {error && <p className="form-error" data-testid="instagram-add-error">{typeof error === "string" ? error : "Please check the URL."}</p>}
        <button className="button button-primary" disabled={state === "saving"} data-testid="instagram-add-button">{state === "saving" ? <><LoaderCircle className="spin"/> Verifying</> : <><Plus/> Add post</>}</button>
      </form>
      {posts.length === 0 && <p className="admin-empty" data-testid="instagram-empty">No Instagram posts curated yet. Paste a public post URL above to publish it on the site.</p>}
      <div className="instagram-admin-list">
        {posts.map((post) => (
          <article key={post.post_id} data-testid={`instagram-admin-${post.post_id}`}>
            <div><Instagram/><div><a href={post.permalink} target="_blank" rel="noreferrer">{post.permalink}</a><p>{post.caption || "No caption"} · Added {formatDate(post.created_at)}</p></div></div>
            <button onClick={() => remove(post)} data-testid={`instagram-delete-${post.post_id}`}><Trash2/> Remove</button>
          </article>
        ))}
      </div>
    </section>
  );
};
